import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { obtenerProductoresEncargadoAdmin, guardarProductoresEncargadoAdmin } from '../../services/adminEncargados';
import AppShell from '../../components/layout/AppShell';
import Button from '../../components/ui/Button';

function AdminEncargadoProductoresPage() {
  const { id } = useParams();

  const [encargado, setEncargado] = useState(null);
  const [productoresIds, setProductoresIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  const [saved, setSaved] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    setLoadError('');
    setSaved(false);

    const result = await obtenerProductoresEncargadoAdmin(id);
    if (!result.ok) {
      setLoadError(result.message);
      setEncargado(null);
      setLoading(false);
      return;
    }

    setEncargado(result.encargado);
    setProductoresIds((result.encargado?.productores ?? []).filter((p) => p.asignado).map((p) => p.id));
    setLoading(false);
  }, [id]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  const toggleProductor = (idproductor) => {
    setSaved(false);
    setProductoresIds((prev) =>
      prev.includes(idproductor) ? prev.filter((pid) => pid !== idproductor) : [...prev, idproductor]
    );
  };

  const handleGuardar = async () => {
    setSaving(true);
    setSaveError('');
    setSaved(false);

    const result = await guardarProductoresEncargadoAdmin(id, productoresIds);
    setSaving(false);

    if (!result.ok) {
      setSaveError(result.message);
      return;
    }
    setSaved(true);
    cargar();
  };

  if (loading) {
    return (
      <AppShell title="Productores asignados" backTo="/admin/encargados">
        <p className="text-center text-sm text-gray-500">Cargando...</p>
      </AppShell>
    );
  }

  if (loadError || !encargado) {
    return (
      <AppShell title="Productores asignados" backTo="/admin/encargados">
        <p className="text-center text-sm text-red-600">{loadError || 'Encargado no encontrado.'}</p>
      </AppShell>
    );
  }

  return (
    <AppShell title="Productores asignados" backTo="/admin/encargados">
      <div className="flex flex-col gap-6">
        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-gray-900">{encargado.nombre}</h2>
        </div>

        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <p className="mb-3 text-sm font-medium text-gray-700">Productores permitidos *</p>
          <div className="flex flex-col divide-y divide-gray-100 rounded-xl border border-gray-200">
            {encargado.productores.map((productor) => (
              <label key={productor.id} className="flex min-h-[48px] items-center gap-3 px-4 text-sm text-gray-900">
                <input
                  type="checkbox"
                  checked={productoresIds.includes(productor.id)}
                  onChange={() => toggleProductor(productor.id)}
                  className="h-5 w-5 shrink-0 rounded border-gray-300 text-green-600 focus:ring-green-500"
                />
                {productor.nombre}
              </label>
            ))}
          </div>

          <p className="mt-4 text-xs text-gray-400">
            Debe quedar al menos un productor seleccionado: un encargado no puede operar sin productor.
          </p>
        </div>

        {saveError && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{saveError}</p>}
        {saved && <p className="rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700">Asignación guardada.</p>}

        <Button onClick={handleGuardar} disabled={saving || productoresIds.length === 0}>
          {saving ? 'Guardando...' : 'Guardar'}
        </Button>
      </div>
    </AppShell>
  );
}

export default AdminEncargadoProductoresPage;
